import React from 'react';
import { observer } from 'mobx-react-lite';
import { BetShopBankerCards } from '../betShopBankerCards';
import { BetShopPlayerCards } from '../betShopPlayerCards';

export const BetShopCardsSection = observer(() => {
  return (
    <div className='bb-cards-holder'>
      {/* Add class bb-disabled for bb-cards, when win banner popup is visible */}
      <BetShopPlayerCards />
      <BetShopBankerCards />
    </div>
  );
});
